module.exports = __webpack_public_path__ + "img/A-3674203-1461621757-8146.jpeg.b29e8e22.jpg";